import { render, staticRenderFns } from "./AdminTipiFabbricatoView.vue?vue&type=template&id=64580fcc&"
import script from "./AdminTipiFabbricatoView.vue?vue&type=script&lang=ts&"
export * from "./AdminTipiFabbricatoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports